import { deviceLog } from "./deviceLogsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useNotification from "../../components/notification/useNotification";
import {
  IDeviceLogsPayload,
  IDeviceLogsResponse,
  IDeviceLogsState,
} from "../../common/types/devicesTypes";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { isSuccessResponse } from "../../common/utils";
import { AxiosError } from "axios";
import { ISuccsessResponse } from "../../common/types/uiTypes";
import { useSpinner } from "../../customHooks";
import { ERROR_MESSAGES } from "../../common/constants";

interface IProps {
  deviceId: string;
}

interface IDeviceLogsResponseState {
  deviceLogs: IDeviceLogsState;
}

export const useDeviceLogs = (props: IProps) => {
  const { deviceId } = props;
  const dispatch: ThunkDispatch<IDeviceLogsResponse, undefined, Action> =
    useDispatch();
  const { showSuccessNotification, showWarningNotification } =
    useNotification();
  const deviceLogsResponse = useSelector(
    (state: IDeviceLogsResponseState) => state.deviceLogs
  );
  const [downloadLink, setDownloadLink] = useState<string>();
  const [isDownloadDisabled, setIsDownloadDisabled] = useState<boolean>(true);

  useEffect(() => {
    setIsDownloadDisabled(!downloadLink);
  }, [downloadLink]);

  useEffect(() => {
    setIsDownloadDisabled(true);
  }, [deviceId]);

  useEffect(() => {
    return () => {
      setIsDownloadDisabled(true);
    };
  }, []);

  const handleDownloadLogs = (): void => {
    if (downloadLink) {
      const link: HTMLAnchorElement = document.createElement("a");
      link.href = downloadLink;
      link.click();
    }
  };

  useSpinner(deviceLogsResponse.status);

  const handleRetrieveLogsButtonClick = (): void => {
    if (!deviceId) {
      showWarningNotification(ERROR_MESSAGES.DEVICE_ID_EMPTY);
      return;
    }
    const deviceLogsPayload: IDeviceLogsPayload = {
      deviceId: deviceId,
    };
    dispatch(deviceLog(deviceLogsPayload)).then((response) => {
      const deviceLogsResponse = response.payload as
        | AxiosError
        | ISuccsessResponse;
      if (isSuccessResponse(deviceLogsResponse)) {
        showSuccessNotification(deviceLogsResponse.message);
        if ("link" in deviceLogsResponse)
          setDownloadLink(deviceLogsResponse.link);
      } else {
        showWarningNotification(deviceLogsResponse.response.data.message);
      }
    });
  };

  return {
    handleRetrieveLogsButtonClick,
    downloadLink,
    isDownloadDisabled,
    handleDownloadLogs,
  };
};
